<template>
  <fragment>
    <v-container
      grid-list-md
      class="pets"
    >
      <v-layout
        wrap
        justify-center
      >
        <v-flex
          text-md-right
          text-xs-right
          xs12
          md8
        >
          <v-btn
            fab
            small
            color="secondary"
            class="add-button"
            @click="openAddDialog"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
        <PetList
          @openEditDialog="openEditDialog"
          @openDeleteDialog="openDeleteDialog"
        />
      </v-layout>
    </v-container>
    <PetDialog
      v-model="dialog"
      :type="type"
      :pet-data="petData"
    />
    <DeletePetDialog
      v-model="deleteDialog"
      :pet-data="petData"
    />
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import PetList from '../components/pets/PetList'
import PetDialog from '../components/pets/PetDialog'
import DeletePetDialog from '../components/pets/DeletePetDialog'

export default {
  name: 'PetsPage',
  components: {
    PetList,
    PetDialog,
    DeletePetDialog,
    Fragment,
  },
  data() {
    return {
      deleteDialog: false,
      dialog: false,
      type: 'new',
      petData: {},
    }
  },
  methods: {
    openEditDialog(pet) {
      this.type = 'edit'
      this.petData = pet
      this.dialog = true
    },
    openAddDialog() {
      this.type = 'new'
      this.dialog = true
    },
    openDeleteDialog(pet) {
      this.petData = pet
      this.deleteDialog = true
    },
  },
}
</script>
<style lang="stylus">
  .add-button {
    margin-bottom: 15px;
  }
  @media only screen and (min-width: 960px) {
    .pets {
      margin-top: 50px;
    }
  }
</style>
